import { CommandGroup, CommandItem } from "@/components/ui/command";

const PaginatedLoader = (): JSX.Element => {
  return (
    <CommandGroup>
      {[1, 2, 3].map((i) => (
        <CommandItem key={i} disabled>
          <div className='flex items-center gap-2 w-full'>
            <div className='h-6 w-6 rounded-full animate-pulse bg-muted' />
            <div className='flex flex-col flex-1 gap-1'>
              <div className='h-4 w-24 animate-pulse bg-muted rounded' />
              <div className='h-3 w-16 animate-pulse bg-muted rounded' />
            </div>
          </div>
        </CommandItem>
      ))}
    </CommandGroup>
  );
};

export default PaginatedLoader;
